import React from 'react'
import Main from "../components/main/Main"
import Footer from '../components/footer/Footer'

export default function HomePageComponent() {
  return (
    <div className="container">
      <div>
        <Main />
        <Footer />
      </div>
    </div>
  );
}
